export const getFromAPI = async (URL) => {
    try {
        const DATA = await fetch(URL).then(async (response) => {
            let result;
            try {
                result = await response.json();

                if (result.message?.type === "Error") {
                    result.message = {
                        ...result.message,
                        text: result.message.pl,
                        text_en: result.message.en,
                    };
                }

                if (result.error_code) {
                    result.errcode = result.error_code;
                    result.message = {
                        ...result,
                        type: "Error",
                        text: result.error_reason,
                        text_en: result.error_reason,
                    };
                }
            } catch (e) {
                console.log("catch 1", e);
                result = {
                    ...result,
                    message: {
                        type: "Error",
                        text: `Błąd API (${response.status})`,
                        text_en: `API error (${response.status})`,
                    },
                    errcode: response.status,
                };
            }
            if (!response.ok) {
                result = {
                    ...result,
                    message: {
                        type: "Error",
                        text: result.error_reason || `Błąd API (${response.status})`,
                        text_en: result.error_reason || `API error (${response.status})`,
                    },
                    error: true,
                };
            }
            return result;
        });
        return DATA;
    } catch (error) {
        console.log("catch 2", error);
        return {
            message: {
                type: "Error",
                text: `Błąd API${error.message ? `: "${error.message}"` : ""}`,
                text_en: `API error${error.message ? `: "${error.message}"` : ""}`,
            },
        };
    }
};

export const wrongParams = (description = "") => {
    return {
        message: {
            type: "Error",
            text: `Wrong parameters for request${description ? ` (${description})` : ""}`,
        },
    };
};
